import type { App } from 'vue'

let installed = false

/** 按需加载并注册 VueKonva，仅执行一次；进入使用 Konva 的页面（如分镜-局部重绘）前调用 */
export const ensureVueKonva = async (app: App): Promise<void> => {
  if (installed) return
  const { default: VueKonva } = await import('vue-konva')
  app.use(VueKonva)
  installed = true
}
